import { Form, FormInstance } from "antd";
import CompanyCard from "containers/Admin/CreateOrEditEvent/Cards/CompanyCard";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { EditEventFormType } from "../CreateOrEditEvent";

interface Props {
  form: FormInstance<EditEventFormType>;
}

const CompanyCardDescription: React.FC<Props> = ({ form }) => {
  const comments = form.getFieldValue("comments");

  const onDescriptionChange = (value: string) => {
    form.setFieldsValue({ description: value });
  };
  return (
    <>
      <CompanyCard title="Beskrivelse">
        <Form.Item name="comments">
          <ReactQuill
            theme="snow"
            onChange={onDescriptionChange}
            value={comments}
            placeholder="Legg inn beskrivelse av arrangementet her..."
          />
        </Form.Item>
      </CompanyCard>
    </>
  );
};

export default CompanyCardDescription;
